import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// Same default brand color denzo-web falls back to when a store hasn't
// customized its own theme_color. Wire this up to store.theme_color from
// get-store once per-store branding is wanted here too.
const BRAND_COLOR = "#c62828";

let theme = createTheme({
  shape: { borderRadius: 12 },
  palette: {
    primary: { main: BRAND_COLOR, contrastText: "#fff" },
    background: { default: "#faf7f5" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
export { BRAND_COLOR };
